export function useSlugTransform(inputString: string): string[] {
  // Убираем слеши в начале и конце строки
  const trimmedString = inputString?.replace(/^\/+|\/+$/g, '');

  // Возвращаем результат split
  return trimmedString.split('/');
}
